import { MessageBarBody, MessageBarTitle, Input } from '@fluentui/react-components';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ErrorMessageComponent } from '../../../Error/ErrorMessageComponent';

// component functions
import * as ComponentFunctions from './CycleForm.Functions';
import { StageCycle } from '../../../../models/Entities/Contracts/StageCycle';
import { NewStageCycle } from '../../../../models/Entities/Contracts/NewStageCycle';

// guide components
import { GuideDrawer, GuideDrawerForm } from '../../../../theme/components/GuideDrawer';
import { GuideField } from '../../../../theme/components/GuideField';
import { GuideMessageBar } from '../../../../theme/components/GuideMessageBar';

////i18Next
import { useTranslation } from 'react-i18next';

interface FormValidation {
    success: boolean;
    errors: string[];
}
    
export const CycleFormComponent = (props: ComponentFunctions.Props) => {

const [submittedForm, setSubmittedForm] = useState<boolean>(false);
const [FormValidationStatus, setFormValidationStatus] = useState<
    FormValidation | undefined
>();

// entity properties
/*
    contractId: number;
    cycle: string;
    order: number;
    cycleName: string;
*/


const [cycleName, setCycleName] = useState<string>();
const [order, setOrder] = useState<number>(0);
const [cycle, setCycle] = useState<string>();
const [cycleId, setCycleId] = useState<number>();

//useTranslation()
const [t] = useTranslation();

//load necesary data
useEffect(() => {
    props.GetContractById(props.ContractId);
    if (props.ContractStageCycleId) props.GetContractStageCycleById(props.ContractStageCycleId);
}, []);

useEffect(() => {
    if (submittedForm && props.isSavedSuccessfully) {
        setSubmittedForm(false);
        ResetForm();
        props.dismissPanel();
    }
}, [submittedForm, props.isSavedSuccessfully]);


useEffect(() => {
    if (props.ContractStageCycle) {
        setCycleName(props.ContractStageCycle.cycleName);
        setOrder(props.ContractStageCycle.order);
        setCycle(props.ContractStageCycle.cycle);
        setCycleId(props.ContractStageCycle.id);
    }
}, [props.ContractStageCycle]);

const ResetForm = () => {
    setSubmittedForm(false);
    setCycleName('');
    setOrder(0);
    setCycle('');
    setCycleId(undefined);
};


// Events
const HandleSaveForm = () => {
    setSubmittedForm(true);
    if (ValidateForm()) {
    let CurrentValues: StageCycle | NewStageCycle;
    if (props.ContractStageCycle) {
      CurrentValues = {
        id: props.ContractStageCycle.id,
        contractId: props.ContractId,
        contractAddendumId: props.ContractAddendumId,
        cycleName: cycleName!,
        order: order!,
        cycle: cycle!
      };
      props.UpdateContractStageCycle(CurrentValues as StageCycle);
    } else {
      CurrentValues = {
        contractId: props.ContractId,
        contractAddendumId: props.ContractAddendumId,
        cycleName: cycleName!,
        order: order!,
        cycle: cycle!
      };
      props.AddContractStageCycle(CurrentValues as NewStageCycle);
    }
    }
};

const HandleCancelForm = () => {
    ResetForm();
    props.dismissPanel();
};

// form validation

const ValidateForm = (): boolean => {
    let validationResult: boolean = true;

    let FormValidation: FormValidation = { success: true, errors: [] };
    setFormValidationStatus(FormValidation);

    if (!cycleName) {
        validationResult = false;
        FormValidation.errors.push(t('cycleForm.formFields.errorMessage'));
    }

    FormValidation.success = validationResult;
    setFormValidationStatus(FormValidation);
    return validationResult;
};

return (
    <GuideDrawer
    open={props.isOpen}
    size="small"
    eyebrow={props.Contract?.contractNumber}
    title={t('cycleForm.panel.cycleInformation')}
    onDismiss={props.dismissPanel}
    testId="cycle-form-drawer"
    secondaryAction={{ label: t('cycleForm.footer.cancelButton'), onClick: HandleCancelForm }}
    primaryAction={{
        label: props.isSaving ? t('cycleForm.footer.saving') : t('cycleForm.footer.saveButton'),
        onClick: HandleSaveForm,
        loading: props.isSaving,
    }}
    >
    {submittedForm && !FormValidationStatus?.success && (
        <GuideMessageBar intent="error">
        <MessageBarBody>
            <MessageBarTitle>{t('cycleForm.panel.reviewInformation')}</MessageBarTitle>
            <ul>
            {FormValidationStatus?.errors.map(
                (Error: string, index: number) => (
                <li key={index}>{Error}</li>
                )
            )}
            </ul>
        </MessageBarBody>
        </GuideMessageBar>
    )}
    {props.failOnSaving &&
    props.error && (
        <ErrorMessageComponent Error={props.error} />
    )}
    <GuideDrawerForm onSubmit={HandleSaveForm} testId="cycle-form">
        <GuideField
        label={t('cycleForm.formFields.cycleName')}
        required
        error={submittedForm && !cycleName ? t('cycleForm.formFields.errorMessage') : undefined}
        >
        <Input value={cycleName ?? ''} onChange={(_, data) => setCycleName(data.value)} />
        </GuideField>
    </GuideDrawerForm>
    </GuideDrawer>
);
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(CycleFormComponent as any);
